import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', path: '/' },
  { label: '校园恋爱', path: '/category/school-romance' },
  { label: '奇幻冒险', path: '/category/fantasy' },
  { label: '热血动作', path: '/category/action' },
  { label: '悬疑惊悚', path: '/category/thriller' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header>
      <nav
        className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-comic-dark/95 backdrop-blur-md border-b border-comic-border'
            : 'bg-transparent'
        }`}
        role="navigation"
        aria-label="主导航"
      >
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="flex items-center justify-between h-16">
            <Link
              to="/"
              className="flex items-center gap-2 group"
              aria-label="韩国漫画网首页"
            >
              <span className="text-2xl md:text-3xl font-display tracking-tighter text-white relative">
                <span className="bg-gradient-to-r from-comic-primary to-comic-accent bg-clip-text text-transparent">
                  K
                </span>
                <span className="text-white">MANHUA</span>
                <span className="absolute -top-1 -right-2 w-2 h-2 bg-comic-accent rounded-full animate-pulse-glow"></span>
              </span>
            </Link>

            {/* 桌面端导航 */}
            <div className="hidden md:flex items-center gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                    location.pathname === link.path
                      ? 'text-comic-primary'
                      : 'text-gray-300 hover:text-white'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </div>

            {/* 右侧操作区 */}
            <div className="hidden md:flex items-center gap-4">
              <button
                className="px-5 py-2 rounded-full border border-comic-cyan/40 bg-white/5 backdrop-blur-sm text-comic-cyan text-sm font-medium hover:bg-comic-cyan/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
                aria-label="开始阅读"
              >
                <i className="ri-book-open-line mr-1.5"></i>
                开始阅读
              </button>
            </div>

            {/* 移动端汉堡按钮 */}
            <button
              className="md:hidden flex items-center justify-center w-10 h-10 text-white cursor-pointer"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="打开菜单"
              aria-expanded={mobileOpen}
            >
              <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {/* 移动端菜单 */}
        {mobileOpen && (
          <div className="md:hidden bg-comic-dark/98 backdrop-blur-md border-t border-comic-border animate-fade-in">
            <div className="px-4 py-4 flex flex-col gap-3">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm py-2 transition-colors duration-200 ${
                    location.pathname === link.path
                      ? 'text-comic-primary'
                      : 'text-gray-300 hover:text-white'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <button className="mt-2 px-5 py-2 rounded-full border border-comic-cyan/40 bg-white/5 text-comic-cyan text-sm font-medium text-center whitespace-nowrap cursor-pointer">
                <i className="ri-book-open-line mr-1.5"></i>
                开始阅读
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}